// db/default-serialize-functions.ts
import { DateTime } from "luxon";
function serializeDate(format = DateTime.DATE_SHORT) {
  return (date) => date?.toLocaleString(format) ?? "";
}
function serializeTime(format = DateTime.DATETIME_SHORT) {
  return (date) => date?.toLocaleString(format) ?? "";
}
export {
  serializeDate,
  serializeTime
};
